export default {
    primaryBlue: '#2d5ab4',
    primaryGreen: '#6eb43c',
    dangerBackground: ' #cc0000'
};


// WEBPACK FOOTER //
// ./services/constants/colourCodes.js